var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reporting"},[_c('p',[_vm._v("Pode efetuar extrações diárias e mensais manualmente utilizando o widget abaixo.")]),_c('widget-options',[(_vm.$store.getters.can( 'reporting', 'dailyReporting' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleModal( 'dailyReporting' ); },
                label: 'dailyReporting'
            }}}):_vm._e(),(_vm.$store.getters.can( 'reporting', 'monthlyReporting' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleModal( 'monthlyReporting' ); },
                label: 'monthlyReporting'
            }}}):_vm._e()],1),(_vm.modal.show)?_c('modal',{key:_vm.modal.show,attrs:{"form":{
            class: 'modal__form--action display--flex',
            settings: {
                submissionType: _vm.modal[_vm.modal.type].action
            }
        },"customSettings":{
            color: 'green',
            button: {
                label: 'export'
            }
        },"executeCloseAction":!_vm.modal.loading},on:{"close":function($event){return _vm.toggleModal( _vm.modal.type )}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"modal__header"},[_vm._v(_vm._s(_vm.$t('global.exportType', { type: _vm.$t(("global." + (_vm.modal.type))) } )))])]},proxy:true},{key:"modal__body",fn:function(){return [(_vm.modal.type == 'dailyReporting')?_c('base-field',{staticClass:"reporting__modal__body__date",attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.date') },
                    input: {
                        component: 'InputCalendar',
                        name: 'date',
                        id: 'date',
                        targetClass: 'field__input--default typography--default color--default',
                        value: '',
                        dynamicData: {
                            configs: {
                                format: 'DD-MM-YYYY',
                                hideInput: false,
                                maxDate: new Date(),
                            }
                        },
                        browserAutocomplete: 'off',
                        isRequired: false,
                        isMissing: _vm.errors.missing.date,
                        errorOnSubmit: {
                            show: _vm.errors.api.date ? true : false,
                            messages: _vm.errors.api.date
                        },
                    },
                    reset: _vm.reset,
                    allowFilling: true
                }}}):_vm._e(),(_vm.modal.type == 'monthlyReporting')?_c('base-field',{staticClass:"search__calendar",staticStyle:{"margin-right":"20px"},attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.date') },
                    input: {
                        component: 'InputRangeCalendar',
                        name: 'reportingRange',
                        id: 'reportingRange',
                        targetClass: 'field__input--default typography--default color--default',
                        value: '',
                        browserAutocomplete: 'off',
                        noListener: true,
                        dynamicData: {
                            configs: {
                                hideInput: false,
                                maxDate: new Date(),
                            }
                        },
                        isRequired: false,
                        isMissing: _vm.errors.missing.fromDate,
                        errorOnSubmit: {
                            show: _vm.errors.api.fromDate ? true : false,
                            messages: _vm.errors.api.fromDate
                        }
                    },
                    reset: _vm.reset,
                    allowFilling: true
                }}}):_vm._e(),(_vm.modal.type == 'monthlyReporting')?_c('base-field',{staticClass:"reporting__campaigns",attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.campaign') },
                    input: {
                        component: 'InputAutocomplete',
                        name: 'campaignName',
                        id: 'campaignName',
                        type: 'text',
                        value: '',
                        targetClass: 'reporting__campaigns__input field__input--default typography--default color--default',
                        browserAutocomplete: 'off',
                        dynamicData: {
                            data: _vm.campaigns,
                        },
                        noListener: true
                    },
                    allowFilling: true
                }}}):_vm._e()]},proxy:true},{key:"modal__info",fn:function(){return [_c('base-button',{staticClass:"modal__content__button--negative background--transparent border--grey",class:{ 'disable': _vm.modal.loading },domProps:{"innerHTML":_vm._s(_vm.$t('global.cancel'))},on:{"click":function($event){return _vm.toggleModal( _vm.modal.type )}}})]},proxy:true}],null,false,3378020762)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }